import PropTypes from 'prop-types';
import { Component } from 'react';
import { ErrorComponent } from '../Error/Error';

export class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node,
  };

  state = {
    error: false,
  };

  componentDidCatch() {
    this.setState({ error: true });
  }

  render() {
    const { error } = this.state;
    const { children, ...rest } = this.props;

    if (!error) {
      return children;
    }

    return (
      <div className="Checkout-content">
        <ErrorComponent {...rest} />
      </div>
    );
  }
}
